import myDate from "../../assets/js/dateManager.js";

//------------------------- INIT -------------------------//
var defVals = {
	"text": "",
	"email": "",
	"choice": "",
	"tel": "",
	"password": "",
	"date": myDate.displayCurrentDate({sequence: "y-m-d"}),
	"time": myDate.displayCurrentTime({sequence: "hh:mm", hourFormat: 24}),
	"number": 0,
	"boolean": true,
	"JSON": {},
	"Array": [],
	"Array-Simple": [],
}

function init(template, vue){
	var output;
	var complex = ["JSON", "Array"];
	var initValue = function(template, vue){
		var output
		if (template.Type === "Array"){
			output = [];
		}
		else if (template.Type === "JSON"){
			output = init(template.children, vue);
		}
		else if (template.Type === "choice"){
			var allVals = template.CheckFields.Values.split(",");
			if (template.DefaultValue){
				output = allVals[parseInt(template.DefaultValue)];
			}
			else{
				output = defVals[template.Type];
			}
		}
		else if (template.DefaultValue){
			output = template.DefaultValue;
		}
		else if (template.CheckFields.mustTrue){
			output = false;
		}
		else{
			output = defVals[template.Type];
		}

		if (template.Type === "date"){
			var currentDate = new Date();
			currentDate.setDate(currentDate.getDate() - template.CheckFields.minDate);
			vue[template.Name.replace(/ /g, "") + "Min"] = myDate.displayDate(currentDate.getTime(), {sequence: "y-m-d"});
			currentDate.setDate(currentDate.getDate() + template.CheckFields.minDate + template.CheckFields.maxDate);
			vue[template.Name.replace(/ /g, "") + "Max"] = myDate.displayDate(currentDate.getTime(), {sequence: "y-m-d"});
		}

		return output;
	}
	if (template.constructor === [].constructor){	
		output = {};
		template.forEach(r=>{
			output[r.Name] = initValue(r, vue);
		})
	}
	else{
		output = initValue(template, vue);
	}

	return output;
}


//------------------------- CHECK -------------------------//
function checkMain(input, template){
	var output;
	var error;
	var errorMsg;
	var checkFun = {
		"text"(input, template){
			if (template.Compulsory){
				if (input === ""){
					return {
						error: true,
						errorMsg: "Value is empty",
						output: input
					}
				}
			}
			if (template.Compulsory || input !== ""){
				if (input.length < template.CheckFields.minLength){
					return{
						error: true,
						errorMsg: "Please input at least " + template.CheckFields.minLength + " characters.",
						output: input
					}
				}
				else if ( template.CheckFields.regex && !input.match(new RegExp(template.CheckFields.regex))){
					return{
						error: true,
						errorMsg:  template.CheckFields.errorMsg || "Value is badly formatted.",
						output: input
					}
				}
			}
			return{
				error: false,
				errorMsg: "",
				output: input
			}
		},
		"choice"(input, template){
			if (template.Compulsory){
				if (input === ""){
					return {
						error: true,
						errorMsg: template.CheckFields.errorMsg || "Value is empty",
						output: input
					}
				}
			}
			return{
				error: false,
				errorMsg: "",
				output: input
			}
		},
		"email"(input, template){
			input = input.replace(/ /g, "");
			var notEmail = false;
			var errorMsg = "";
			if (template.Compulsory){
				if (input === ""){
					return {
						error: true,
						errorMsg: template.CheckFields.errorMsg || "Please input an email.",
						output: input
					}
				}
			}
			if (template.Compulsory || input != ""){
				if ( template.CheckFields.regex && !input.match(new Regex(template.CheckFields.regex))){
					return{
						error: true,
						errorMsg: "Email is badly formatted." || template.CheckFields.errorMsg,
						output: input
					}
				}
			}
			return {
				error: notEmail || (input == undefined),
				errorMsg: errorMsg,
				output: input
			}
		},
		"tel"(input, template){
			if (template.Compulsory){
				if (input === ""){
					return {
						error: true,
						errorMsg: template.CheckFields.errorMsg || "Please input a valid phone number.",
						output: input
					}
				}
			}
			var output = "";
			var error = false;
			var errorMsg = "";
			if (template.Compulsory || input != ""){
				input.split("").forEach(r=>{
					if (isNaN(r)){
						error = true;
						errorMsg = "Only numbers are allowed.";
					}
					else{
						output += r;
					}
				})
				input = output;
				if (input.length < template.CheckFields.minLength){
					error = true;
					errorMsg += " Phone number must be " + template.CheckFields.minLength + " digits long.";
				}
				else if ( template.CheckFields.regex && !input.match(new Regex(template.CheckFields.regex))){
					return{
						error: true,
						errorMsg: "Email is badly formatted." || template.CheckFields.errorMsg,
						output: input
					}
				}
			}
			return {
				error: error,
				errorMsg: errorMsg,
				output: input
			}
		},
		"password"(input, template){
			if (template.Compulsory){
				if (input === ""){
					return {
						error: true,
						errorMsg: template.CheckFields.errorMsg || "Please input a password.",
						output: input
					}
				}
			}
			var output = "";
			var error = false;
			var errorMsg = "";
			if (template.Compulsory || input != ""){
				var checkArray = input.split("");
				if (template.CheckFields.type === "Strong"){
					var containsUpper = checkArray.some(r=>{
						return r.toUpperCase() === r;
					})
					var containsLower = checkArray.some(r=>{
						return r.toLowerCase() === r;
					})
					var containsNum = checkArray.some(r=>{
						return !isNaN(r);
					})
					error = !containsUpper || !containsLower || !containsNum;
				}
				if (input.length < template.CheckFields.minLength && error){
					errorMsg = "Password must contain uppercase, lowercase and numbers with at least " + template.CheckFields.minLength + " digits.";
				}
				else if (input.length < template.CheckFields.minLength){
					error = true;
					errorMsg = "Password must be at least " + template.CheckFields.minLength + " digits.";
				}
			}
			return{
				error: error, 
				errorMsg: errorMsg,
				output: input
			}
		},
		"date"(input, template){
			if (template.Compulsory){
				if (input === ""){
					return {
						error: true,
						errorMsg: template.CheckFields.errorMsg || "Please input a date.",
						output: input
					}
				}
			}
			if (template.Compulsory || input != ""){
				if (typeof(input) === "string"){
					if (input.length !== 10){
						error = true;
					}
					var inputArr = input.split("");
					var error = false;
					if (!["-", "/"].includes(inputArr[4])){
						error = true;
					}
					if (!["-", "/"].includes(inputArr[7])){
						error = true;
					}
					for (var i = 0; i<4; i++){
						if (isNaN(inputArr[i])){
							error = true;
						}
					}
					for (var i = 5; i<7; i++){
						if (isNaN(inputArr[i])){
							error = true;
						}
					}
					for (var i = 8; i<10; i++){
						if (isNaN(inputArr[i])){
							error = true;
						}
					}
					if (error){
						return{
							error: true,
							errorMsg: "Invalid date.",
							output: ""
						}
					}
					else{
						return{
							error: false,
							errorMsg: "",
							output: input
						}
					}
				}
				else if (typeof(input) === "number"){
					return{
						error: false,
						errorMsg: "",
						output: myDate.displayDate(input, {sequence: "y-m-d"})
					}
				}
				else{
					return{
						error: true,
						errorMsg: "Invalid date.",
						output: ""
					}
				}
				return{
					error: false,
					errorMsg: "",
					output: 0
				}
			}
			return{
				error: false,
				errorMsg: "",
				output: 0
			}
		},
		"time"(input, template){
			if (typeof(input) === "string"){
				var error = true;
				var inputArr = input.split("");
				switch(input.length){
					case 5:
						//
						error = false;
						if (inputArr[2] !== ":"){
							error = true;
						}
						for (var i = 0; i<2; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						for (var i = 3; i<5; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						break;
					//
					case 8:
						//
						error = false;
						if (inputArr[2] !== ":"){
							error = true;
						}
						if (inputArr[5] !== ":"){
							error = true;
						}
						for (var i = 0; i<2; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						for (var i = 3; i<5; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						for (var i = 6; i<8; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						error = false;
						break;
					//
				}
				if (error){
					return{
						error: true,
						errorMsg: "Invalid time.",
						output: ""
					}
				}
				else{
					return{
						error: false,
						errorMsg: "",
						output: input
					}
				}
			}
			else{
				return{
					error: true,
					errorMsg: "Input is not a string",
					output: ""
				}	
			}
		},
		"number"(input, template){
			if (template.Compulsory){
				if (input === ""){
					return {
						error: true,
						errorMsg: template.CheckFields.errorMsg || "Please input a value.",
						output: input
					}
				}
			}
			var output = parseFloat(input);
			if (output < template.CheckFields.min){
				return {
					error: true,
					errorMsg: "Value cannot be below " + template.CheckFields.min + ".",
					output: output
				}
			}
			else if (output > template.CheckFields.max){
				return {
					error: true,
					errorMsg: "Value cannot be above " + template.CheckFields.max + ".",
					output: output
				}
			}
			return{
				error: false,
				errorMsg: "",
				output: output
			}
		},
		"boolean"(input, template){
			if (template.Compulsory && template.CheckFields.mustTrue && !input){
				return {
					error: true,
					errorMsg: template.CheckFields.errorMsg || "Please check the field.",
					output: input
				}
			}
			var output;
			if (input === "" || input === undefined){
				output = false;
			}
			else if (typeof(input) === "string" && input.toUpperCase() === "TRUE"){
				output = true;
			}
			else if (typeof(input) === "boolean"){
				output = input;
			}
			else{
				output = false;
			}
			return {
				error: false,
				errorMsg: "",
				output: output
			}
		},
		"JSON"(input, template){
			return checkMain(input, template.children);
		},
		"Array"(input, template){
			var output = [];
			var errorMsg = [];
			var error = false;
			var response;
			input.forEach(r=>{
				response = checkMain(r, template.children);
				output.push(response.output);
				errorMsg.push(response.errorMsg);
				error = error || response.error;
			})
			return {
				errorMsg,
				error,
				output
			}
		}
	}
	if (template.constructor === [].constructor){	
		output = {};
		errorMsg = {};
		var response;
		var allInputFields = [];
		for (var field in input){
			allInputFields.push(field);
		}
		template.forEach(r=>{
			allInputFields.splice(allInputFields.indexOf(r.Name), 1);
			response = checkFun[r.Type](input[r.Name], r);
			output[r.Name] = response.output;
			errorMsg[r.Name] = response.errorMsg;
			error = error || response.error;
		})
		allInputFields.forEach(r=>{
			output[r] = myCopier.copy(input[r]);
		})
	}
	else{
		output = checkFun[template.Type](r, template);
	}

	return {
		output,
		error,
		errorMsg
	};
}

function checkStructure(input, template){
	var output;
	var error;
	var disableAdd;
	var errorMsg;
	var checkFun = {
		"text"(input, template){
			if (typeof(input) !== "string"){
				return{
					error: true,
					errorMsg: "Input was not a string.",
					output: ""
				}
			}
			if (input.length > template.CheckFields.maxLength){
				return{
					error: true,
					errorMsg: "Number of character exceeded " + template.CheckFields.maxLength + ".",
					output: input.substring(0, template.CheckFields.length)
				}
			}	
			return{
				error: false,
				errorMsg: "",
				output: input
			}
		},
		"choice"(input, template){
			if (typeof(input) !== "string"){
				return{
					error: true,
					errorMsg: "Input was not a string.",
					output: ""
				}
			}
			return{
				error: false,
				errorMsg: "",
				output: input
			}
		},
		"email"(input, template){
			if (typeof(input) !== "string"){
				return{
					error: true,
					errorMsg: "Input was not a string.",
					output: ""
				}
			}
			input = input.replace(/ /g, "");
			var notEmail = false;
			var errorMsg = "";
			if (template.Compulsory){
				if (input === ""){
					return {
						error: true,
						errorMsg: template.CheckFields.errorMsg || "Please input an email.",
						output: input
					}
				}
			}
			var aliasIndex = input.indexOf("@");  
			if (aliasIndex == -1){
				notEmail = true;
				errorMsg = "Missing an @.";
			}
			else{
				var subsequent = input.substring(aliasIndex + 1, input.length - 1);
				if (!subsequent.includes(".")){
					notEmail = true;
					errorMsg = "Missing domain.";
				}
			}
			return {
				error: notEmail || (input == undefined),
				errorMsg: errorMsg,
				output: input
			}
		},
		"tel"(input, template){
			if (typeof(input) !== "string"){
				return{
					error: true,
					errorMsg: "Input was not a string.",
					output: ""
				}
			}
			var output = "";
			var error = false;
			var errorMsg = "";
			if (template.Compulsory || input != ""){
				input.split("").forEach(r=>{
					if (isNaN(r)){
						error = true;
						errorMsg = "Only numbers are allowed.";
					}
					else{
						output += r;
					}
				})
				input = output;
				if (input.length < template.CheckFields.minLength){
					error = true;
					errorMsg += " Phone number must be " + template.CheckFields.minLength + " digits long.";
				}
			}
			return {
				error: error,
				errorMsg: errorMsg,
				output: input
			}
		},
		"password"(input, template){
			if (typeof(input) !== "string"){
				return{
					error: true,
					errorMsg: "Input was not a string.",
					output: ""
				}
			}
			var output = "";
			var error = false;
			var errorMsg = "";
			var checkArray = input.split("");
			if (template.CheckFields.type === "Strong"){
				var containsUpper = checkArray.some(r=>{
					return r.toUpperCase() === r;
				})
				var containsLower = checkArray.some(r=>{
					return r.toLowerCase() === r;
				})
				var containsNum = checkArray.some(r=>{
					return !isNaN(r);
				})
				error = !containsUpper || !containsLower || !containsNum;
			}
			if (input.length < template.CheckFields.minLength && error){
				errorMsg = "Password must contain uppercase, lowercase and numbers with at least " + template.CheckFields.minLength + " digits.";
			}
			else if (input.length < template.CheckFields.minLength){
				error = true;
				errorMsg = "Password must be at least " + template.CheckFields.minLength + " digits.";
			}
			return{
				error: error, 
				errorMsg: errorMsg,
				output: input
			}
		},
		"date"(input, template){
			if (typeof(input) === "string"){
				if (input.length !== 10){
					error = true;
				}
				var inputArr = input.split("");
				var error = false;
				if (!["-", "/"].includes(inputArr[4])){
					error = true;
				}
				if (!["-", "/"].includes(inputArr[7])){
					error = true;
				}
				for (var i = 0; i<4; i++){
					if (isNaN(inputArr[i])){
						error = true;
					}
				}
				for (var i = 5; i<7; i++){
					if (isNaN(inputArr[i])){
						error = true;
					}
				}
				for (var i = 8; i<10; i++){
					if (isNaN(inputArr[i])){
						error = true;
					}
				}
				if (error){
					return{
						error: true,
						errorMsg: "Invalid date.",
						output: ""
					}
				}
				else{
					return{
						error: false,
						errorMsg: "",
						output: input
					}
				}
			}
			else if (typeof(input) === "number"){
				return{
					error: false,
					errorMsg: "",
					output: myDate.displayDate(input, {sequence: "y-m-d"})
				}
			}
			else{
				return{
					error: true,
					errorMsg: "Invalid date.",
					output: ""
				}
			}
			return{
				error: false,
				errorMsg: "",
				output: 0
			}
		},
		"time"(input, template){
			if (typeof(input) === "string"){
				var error = true;
				var inputArr = input.split("");
				switch(input.length){
					case 5:
						//
						error = false;
						if (inputArr[2] !== ":"){
							error = true;
						}
						for (var i = 0; i<2; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						for (var i = 3; i<5; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						break;
					//
					case 8:
						//
						error = false;
						if (inputArr[2] !== ":"){
							error = true;
						}
						if (inputArr[5] !== ":"){
							error = true;
						}
						for (var i = 0; i<2; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						for (var i = 3; i<5; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						for (var i = 6; i<8; i++){
							if (isNaN(inputArr[i])){
								error = true;
							}
						}
						error = false;
						break;
					//
				}
				if (error){
					return{
						error: true,
						errorMsg: "Invalid time.",
						output: ""
					}
				}
				else{
					return{
						error: false,
						errorMsg: "",
						output: input
					}
				}
			}
			else{
				return{
					error: true,
					errorMsg: "Input is not a string",
					output: input
				}	
			}
		},
		"number"(input, template){
			var output = parseFloat(input);
			if (output < template.CheckFields.min){
				return {
					error: true,
					errorMsg: "Value cannot be below " + template.CheckFields.min + ".",
					output: output
				}
			}
			else if (output > template.CheckFields.max){
				return {
					error: true,
					errorMsg: "Value cannot be above " + template.CheckFields.max + ".",
					output: output
				}
			}
			return{
				error: false,
				errorMsg: "",
				output: output.toString()
			}
		},
		"boolean"(input, template){
			return {
				error: false,
				errorMsg: "",
				output: parseBoolean(input)
			}
		},
		"JSON"(input, template){
			return checkStructure(input, template.children);
		},
		"Array"(input, template){
			var output = [];
			var errorMsg = [];
			var error = false;
			var response;
			input.forEach(r=>{
				response = checkStructure(r, template.children);
				output.push(response.output);
				errorMsg.push(response.errorMsg);
				error = error || response.error;
			})
			return {
				errorMsg,
				error,
				output
			}
		}
	}
	if (template.constructor === [].constructor){	
		output = {};
		errorMsg = {};
		var response;
		var allInputFields = [];
		for (var field in input){
			allInputFields.push(field);
		}
		if (input.constructor === {}.constructor){
			template.forEach(r=>{
				allInputFields.splice(allInputFields.indexOf(r.Name), 1);
				if (input[r.Name] === undefined){
					disableAdd = true;
					input[r.Name] = r.DefaultValue;
				}
				response = checkFun[r.Type]((input[r.Name]), r);
				output[r.Name] = response.output;
				errorMsg[r.Name] = response.errorMsg;
				error = error || response.error;
				disableAdd = disableAdd || response.disableAdd;
			})
			if (allInputFields.length > 0){
				disableAdd = true;
			}
		}
		else if (input.constructor === [].constructor){
			output = [];
			errorMsg = [];
			template.forEach(r=>{
				allInputFields.splice(allInputFields.indexOf(r.Name), 1);
			})
			if (allInputFields.length > 0){
				disableAdd = true;
			}
			input.forEach(inp=>{
				var outputNow = {};
				var errorMsgNow = {};
				template.forEach(r=>{
					if (inp[r.Name] === undefined){
						disableAdd = true;
						inp[r.Name] = r.DefaultValue;
					}
					response = checkFun[r.Type]((inp[r.Name]), r);
					outputNow[r.Name] = response.output;
					errorMsgNow[r.Name] = response.errorMsg;
					error = error || response.error;
					disableAdd = disableAdd || response.disableAdd;
				})
				output.push(outputNow);
				errorMsg.push(errorMsgNow);
			})
		}
	}
	else{
		var response = checkFun[template.Type](input, template);
		return {
			output: response.output,
			error: error || response.error,
			errorMsg: response.errorMsg,
			disableAdd: disableAdd || response.disableAdd
		}
	}

	return {
		output,
		error,
		errorMsg,
		disableAdd
	};
}
function checkEmpty(input){
	var notEmpty = false;
	if (input.constructor === {}.constructor){
		for (var item in input){
			notEmpty = notEmpty || checkEmpty(input[item]);
		}
	}
	else if (input.constructor === [].constructor){
		input.forEach(r=>{
			notEmpty = notEmpty || checkEmpty(r);
		})
	}
	else{
		switch (typeof(input)){
			case "number":
				//
				notEmpty =  notEmpty || input.toString() !== "";
				break;
			//
			case "string":
				//
				notEmpty =  notEmpty || input.toString() !== "";
				break;
			//
			case "boolean":
				//
				notEmpty =  notEmpty || input.toString() !== "";
				break;
			//
			case "undefined":
				//
				break;
			//
		}
	}
	return notEmpty;
}

//------------------------- EDIT -------------------------//
function editMain(input, template){
	var output;
	var checkFun = {
		"text"(input){
			return input;
		},
		"choice"(input){
			return input;
		},
		"email"(input){
			return input;
		},
		"tel"(input){
			return input;
		},
		"password"(input){
			return input;
		},
		"date"(input){
			return myDate.displayDate(input, {sequence: "y-m-d"});
		},
		"time"(input){
			return input;
		},
		"number"(input){
			return input.toString();
		},
		"boolean"(input){
			return input;
		},
		"JSON"(input, template){
			return editMain(input, template.children);
		},
		"Array"(input, template){
			var output = [];
			var response;
			input.forEach(r=>{
				output.push(editMain(r, template.children));
			})
			return output
		},
		"Array-Simple"(input){
			return input;
		},
	}
	if (template.constructor === [].constructor){	
		output = {};
		var response;
		template.forEach(r=>{
			output[r.Name] = checkFun[r.Type](input[r.Name], r);
		})
	}
	else{
		output = checkFun[template.Type](r, template);
	}

	return output;
}


//------------------------- MISC -------------------------//
var valueChanger = function(input, elementNames, indices, itemTemplate, newValue){
	var output = myCopier.copy(input);
	var temp = myCopier.copy(itemTemplate).filter(r=>{
		return r.Name === elementNames[0];
	})[0];
	if (temp.Type === "Array"){
		if (elementNames.length>1){
			// console.log("1: " + output[elementNames[0]][indices[0]])
			output[elementNames[0]][indices[0]] = valueChanger(output[elementNames[0]][indices[0]], indices.slice(1, indices.length), elementNames.slice(1,elementNames.length), temp.children, newValue);
		}
		else if (indices[0]){
			// console.log("2: " + output[elementNames[0]][indices[0]])
			output[elementNames[0]][indices[0]] = newValue;
		}
		else{
			output[elementNames[0]] = newValue;
		}
	}
	else if (elementNames.length>1){
		// console.log("3: " + output[elementNames[0]])
		output[elementNames[0]] = valueChanger(output[elementNames[0]], indices, elementNames.slice(1,elementNames.length), temp.children[0], newValue);
	}
	else{
		// console.log("4: " + output[elementNames[0]])
		output[elementNames[0]] = newValue;
	}

	return output;
}

export default{
	init,
	checkMain,
	editMain,
	checkEmpty,
	checkStructure,
	valueChanger
}


// WEBPACK FOOTER //
// ./src/components/Manager/crudDSInputManager.js